import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 18px 30px 15px 30px;
  border-bottom: 1px solid var(--neutral-2);
  background: var(--white-color);

  p {
    max-width: max-content;
    margin: 0;
    color: var(--neutral-7);

    .announcement-bar--link {
      width: 100%;
    }
  }

  .announcement-bar--sign-in {
    display: flex;
    align-items: center;

    img {
      height: 14px;
      width: auto;
      margin-left: 10px;
      color: white;
    }

    a {
      color: var(--neutral-7) !important;
    }
  }

  @media (max-width: 1450px) {
    p {
      font-size: 14px;
      color: var(--neutral-7) !important;
    }

    .announcement-bar--sign-in {
      a {
        color: var(--neutral-7) !important;
      }
    }
  }

  @media (max-width: 1240px) {
    display: none;
  }
`;

export { Container };
